import React, { useEffect } from "react";
import useUserStore from "../../../utils/storeApp";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import RegistrationOrgForm from "./RegistrationOrgForm";
import XdrSetting from "../XdrSetting";

const RegistrationOrgTopLevel = () => {
  const { customerObj, customerFlag } = useUserStore((state) => ({
    customerObj: state.customerObj,
    customerFlag: state.customerFlag,
  }));

  useEffect(() => {
      const heading = document.querySelector("h1.form-title");
      if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus();
      }
  }, []);

  return (
    <Layout>
      <HeaderOrg />
      <main>
        <section className="layout-container">
          <div 
            className="container" 
             tabIndex="-1"
            >
            <div className="descript-container container-2">
              <h1 className="form-title g-clr" id="TopLevelTitle">
                Registration: Top Level Organization
              </h1>
              {customerObj.Name && customerFlag ? (
                <div className="alert alert-success" role="status" aria-live="polite">
                  {customerObj.Name} has been added successfully! You may start
                  adding new organizations to this customer.
                </div>
              ) : null}
              <p>
                  If you have an NPI (National Provider Identifier) number, enter the
                  10-digit identification number. Otherwise, fill in the information
                  below, selecting the organization's specialty, how emails will be
                  delivered, and the types of services enabled for this organization.
              </p>
            </div>
            <RegistrationOrgForm />
          </div>
          <XdrSetting />
        </section>
      </main>
    </Layout>
  );
};

export default RegistrationOrgTopLevel;
